import React from "react";
import styled from "styled-components";
import { Link } from 'react-router-dom';
import { Typography } from "ui-kit/Typography";

interface MenuItemProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  path?: string;
  isActive?: boolean;
}

export const MenuItem: React.FC<MenuItemProps> = props => {
  return (
    <Container to={props.path || ''} $isActive={!!props.isActive}>
      {props.icon}
      <Typography variant="body2">{props.children}</Typography>
    </Container>
  );
};

const Container = styled(Link)<{ $isActive: boolean; path?: string; }>`
  display: grid;
  align-items: center;
  grid-template-columns: 24px 1fr;
  text-decoration: none;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 10px;
  background-color: ${props => props.$isActive ? '#E2E5FF' : '#FFFFFF'};
  pointer-events: ${props => (!!props.to ? 'auto' : 'none')};
  cursor: ${props => (!!props.to ? 'pointer' : 'not-allowed')};
  
  &:hover {
    background-color: ${props => props.theme.palette.background.menuItemActive};
    
  }
`;
